import sdl from '@jds/react-generated-sdl/JDSAvatarV2Status';
import type { JDSAvatarV2StatusProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSAvatarV2StatusProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    kind = 'dot',
    size = 'medium',
    placement = 'bottom',
    disabled = false,
    ariaLabel = 'Avatar with Status Badge',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { kind, size, placement, disabled, ariaLabel, ...rest },
    'JDSAvatarV2Status',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const AvatarV2Status = withLogic(
  Component
) as React.FC<JDSAvatarV2StatusProps> & { slotName?: string };

AvatarV2Status.displayName = 'AvatarV2Status';
AvatarV2Status.slotName = 'jds_avatar_v_2_status';

export { AvatarV2Status, type JDSAvatarV2StatusProps };
